import React from 'react';
import PropTypes from 'prop-types';

import * as pageStyles from '../../styles/internal-page/internal-page.module.scss';
import * as responsiveStyles from '../../styles/responsive.module.scss';
import clsx from 'clsx';

const ActionElement = ({ children, mobile }) => {
  return (
    <div className={clsx(pageStyles.actionElement,
      {[responsiveStyles.smartphone]: mobile})}
    >
      {children}
    </div>
  );
};

ActionElement.propTypes = {
  children: PropTypes.node.isRequired,
  mobile: PropTypes.bool,
};

export default ActionElement;